import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H1 from '@base/H1/H1';
import H3 from '@base/H3/H3';
import { breakpoints } from '@styles/index';
import Container, { StyledButton } from './styles';

const StyledContainer = styled(Container)`
  padding: 130px 0 120px 0;
  @media (max-width: ${breakpoints.tablet}) {
    padding: 80px 0px 80px;
    place-items: center;
  }
  @media (max-width: ${breakpoints.mobile}) {
    padding: 40px 0px 32px;
  }
`;

const BackgroundColor = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(229, 244, 255, 0.44) 100%
  );
  margin-top: 72px;
  @media (max-width: ${breakpoints.tablet}) {
    margin-top: 56px;
    padding: 0 16px;
  }
`;

const LeftSection = styled.section`
  grid-column: span 11;
  @media (max-width: ${breakpoints.tablet}) {
    grid-column: span 12;
  }
  @media (max-width: ${breakpoints.mobile}) {
    grid-column: span 24;
  }
`;

const Title = styled(H1)`
  font-size: 68px;
  line-height: 100%;
  @media (max-width: ${breakpoints.tablet}) {
    font-size: 40px;
  }
`;

const Description = styled(H3)`
  font-weight: 400;
  line-height: 130%;
  margin-top: 16px;
  margin-bottom: 40px;
  @media (max-width: ${breakpoints.tablet}) {
    margin-bottom: 24px;
    font-size: 18px;
    line-height: 150%;
  }
  @media (max-width: ${breakpoints.mobile}) {
    margin-bottom: 0;
  }
`;

const RightSection = styled.img`
  grid-column: 13/25;
  height: 368px;
  object-fit: cover;
  cursor: pointer;
  user-drag: none;
  user-select: none;
  @media (max-width: ${breakpoints.tablet}) {
    grid-column: 14/25;
    height: 210px;
  }
  @media (max-width: ${breakpoints.mobile}) {
    margin: 24px 0;
    height: 194px;
  }
`;

const LearnMore = styled(StyledButton)`
  margin-top: 8px;
  color: var(--color-i-green);
  border: 1px solid var(--color-i-green);
  background-color: transparent;
`;

const Buttons = styled.div`
  display: none;
  @media (max-width: ${breakpoints.mobile}) {
    display: block;
  }
`;

function HeroBlock({ scrollToForm, understandRef, data }) {
  const { title, subTitle, description, buttonText, image } = data;
  const scrollToUnderstand = () => {
    if (understandRef.current) {
      understandRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return (
    <BackgroundColor>
      <StyledContainer>
        <LeftSection>
          <Title>{title}</Title>
          <Title>{subTitle}</Title>
          <Description>{description}</Description>
          <StyledButton $hideSm onClick={scrollToForm}>
            {buttonText}
          </StyledButton>
        </LeftSection>
        <RightSection
          src={image}
          alt="hero image"
          height="auto"
          width="100%"
          loading="lazy"
        />
        <Buttons>
          <StyledButton onClick={scrollToForm}>{buttonText}</StyledButton>
          <LearnMore onClick={scrollToUnderstand}>Learn more</LearnMore>
        </Buttons>
      </StyledContainer>
    </BackgroundColor>
  );
}

HeroBlock.propTypes = {
  // handleLeadgenOpen: PropTypes.func,
  scrollToForm: PropTypes.func.isRequired,
  understandRef: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired
};

HeroBlock.defaultProps = {
  // handleLeadgenOpen: () => {}
};

export default HeroBlock;
